import { ZAttrMeta } from "./ZAttrMeta";
import { zAttrValue, ZSafeValues, ZUnsafeValues } from "./ZAttrValue";

export const safeAttrValues = (
  unsafeMap: ZUnsafeValues,
  metaMap: Record<string, ZAttrMeta>, // see makeAttrMetaMap from ZSpecification
): ZSafeValues => {
  const result: ZSafeValues = {};
  Object.entries(unsafeMap).forEach(([name, value]) => {
    const meta = metaMap[name];

    // Если метаданные отсутствуют, то атрибут игнорируется.
    // Такое может быть из-за того, что атрибут удалили из спецификации. Но он остался в данных.
    if (!meta) return;

    // TODO: Костыль, чтобы убрать сложные данные, которые не должны показываться в таблице
    // см. buildClassColumns
    if (meta.type.name !== "list") {
      const raw = { type: meta.type.name, value };
      const safe = zAttrValue.safeParse(raw);
      if (!safe.success) {
        throw Error(
          `Для атрибута ${name} ожидается тип "${meta.type.name}", но получено: ${JSON.stringify(value)}`,
        );
      }
      result[name] = safe.data;
    }
  });
  return result;
};
